import PropTypes from "prop-types"
import { useCallback } from "react"
import { useDispatch } from "react-redux"

import { setGiftBundle } from "areas/cart/store/actions"
import { isTestMode } from "helpers/application"

export default function withGiftBundles(WrappedComponent) {
  const GiftBundles = (props) => {
    const { handleGiftBundle, item, itemGiftBundle, source = "cart" } = props
    const selectedGiftBundle =
      itemGiftBundle ||
      item?.addons?.find((addon) => addon.addon_type === "GIFT_BUNDLE")

    const dispatch = useDispatch()

    const selectGiftBundle = useCallback(
      (bundle, callbacks) => {
        dispatch(setGiftBundle(item.id, bundle, "cart", callbacks))
      },
      [item.id]
    )

    const onGiftBundleChange = useCallback(
      (giftBundle, callbacks) => {
        if (!isTestMode) {
          if (giftBundle) {
            if (giftBundle.addon_code === selectedGiftBundle?.addon_code) {
              dataLayer.push({
                event: "added-custom-message-to-gift-bundle",
                source,
              })
            } else {
              dataLayer.push({
                event: "added-gift-bundle-to-cart",
                giftPackaging: giftBundle.id,
                giftType: "GIFT_BUNDLE",
                source,
              })
            }
          } else {
            dataLayer.push({
              event: "removed-gift-bundle-from-cart",
              source,
            })
          }
        }

        if (handleGiftBundle) {
          handleGiftBundle(giftBundle, callbacks)
        } else {
          selectGiftBundle(giftBundle, callbacks)
        }
      },
      [handleGiftBundle, selectGiftBundle, selectedGiftBundle]
    )

    return (
      <WrappedComponent
        {...props}
        handleGiftBundle={onGiftBundleChange}
        selectedGiftBundle={selectedGiftBundle}
        source={source}
      />
    )
  }

  GiftBundles.propTypes = {
    handleGiftBundle: PropTypes.func,
    item: PropTypes.object,
    itemGiftBundle: PropTypes.object,
    source: PropTypes.string,
  }

  return GiftBundles
}
